module.exports = __webpack_public_path__ + "img/img_kiwoom_design2_m.3d26d0a8.png";